export const initialData = {
  tipo: '',
  legislacao: '',
  descricao: ''
}
export default initialData;
